import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { dengarkanKuotaHabis } from '@/lib/api';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';

/**
 * Muncul saat sebuah tindakan ditolak karena kuota paket habis.
 *
 * Sebelum ini, penolakan kuota cuma jadi toast merah berisi kalimat seperti
 * "Kuota 300 baris untuk periode ini sudah habis." Kalimatnya benar, tetapi
 * ia menerangkan masalah tanpa menawarkan jalan keluar, dan halaman paket
 * sendiri tidak pernah muncul di sidebar sehingga pengguna tidak punya cara
 * menemukannya.
 *
 * Dialog ini dipasang sekali di AppLayout dan mendengarkan seluruh permintaan
 * lewat `dengarkanKuotaHabis`. Tidak ada halaman yang perlu tahu soal kuota:
 * di mana pun kuota mentok, jawabannya sama.
 */
export const KuotaHabisDialog = () => {
  const navigate = useNavigate();
  const [pesan, setPesan] = useState(null);

  useEffect(() => dengarkanKuotaHabis((galat) => setPesan(galat.message)), []);

  if (!pesan) return null;

  const tutup = () => setPesan(null);

  return (
    <Modal
      open
      onClose={tutup}
      title="Kuota paket Anda sudah habis"
      description={pesan}
      size="sm"
      footer={
        <div className="flex w-full justify-end gap-2">
          <Button variant="secondary" onClick={tutup}>
            Nanti saja
          </Button>
          <Button
            icon={Sparkles}
            onClick={() => {
              tutup();
              navigate('/billing');
            }}
          >
            Lihat Paket
          </Button>
        </div>
      }
    >
      <div className="space-y-3 text-sm text-[var(--text-secondary)]">
        <p>
          Data yang sudah terkumpul tetap aman dan bisa diunduh seperti biasa. Yang terhenti
          hanya pengumpulan data baru.
        </p>
        <p>
          Kuota dihitung per periode paket. Naik ke paket yang lebih tinggi menambah batasnya
          seketika, dan sisa periode yang sedang berjalan dihitung proporsional.
        </p>
      </div>
    </Modal>
  );
};
